<template>
  <a-time-range-picker
    v-bind="attrs"
    :placeholder="integratePlaceholder"
    :class="[bem.b(), bem.is(isGray ? 'gray-time-range' : '')]"
  >
    <template
      v-for="item in Object.keys($slots).filter((slot) => slot !== 'separator')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template
      v-if="$slots.separator || separatorIcon || separatorText"
      #separator
    >
      <slot v-if="$slots.separator" name="separator" />
      <template v-else>
        <ll-icon v-if="separatorIcon" :icon-name="separatorIcon" />
        <span v-else>{{ separatorText }} </span>
      </template>
    </template>
  </a-time-range-picker>
</template>

<script lang="ts" setup>
import { computed, useAttrs } from 'vue'
// import { TimeRangePicker } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
import { timeRangeProps } from './time-range'

defineOptions({ name: 'LlTimeRange' })

const attrs = useAttrs()
const bem = createNamespace('time-range')

const props = defineProps(timeRangeProps)

const integratePlaceholder = computed(() => {
  return [
    props.startPlaceholder || props.placeholder?.[0],
    props.endPlaceholder || props.placeholder?.[1],
  ]
})
</script>
